// Default
export const HEIGHT = 'height'
export const WEIGHT = 'weight'
export const AGE = 'age'
export const HABITS = 'habits'
export const TEMPERATURE = 'temperature'

// Optional
export const STRESS = 'stress'
export const GLUCOSE = 'glucose'
export const BLOOD_TYPE = 'blood'
export const HEART_RATE = 'heartRate'
export const BLOOD_PRESSURE = 'presure'
export const HDL_CHOLESTEROL = 'hdl'
export const LDL_CHOLESTEROL = 'ldl'
export const CHOLESTEROL = 'cholesterol'
export const TRIGLYCERIDES = 'triglycerides'
export const BODY_MASS = 'bodyMass'
export const BREATHING_FREQUENCY = 'breathingFrequency'
export const OXYGEN_SATURATION = 'oxygenSaturation'
export const FEEDING_QUALITY = 'feeding'
export const SLEEP_QUALITY = 'sleep'
export const EXERCISE_AMOUNT = 'exercise'
export const WAIST_SIZE = 'waist'
export const HIP_SIZE = 'hip'
export const MOOD_LEVEL = 'mood'
export const FAT_MASS = 'fatMass'
export const FREE_FAT_MASS = 'fatFreeMass'
export const HOMA = 'homa'
export const VITAMIN_D = 'vitaminD'
export const STEPS_NUMBER = 'steps'
export const CALORIES = 'calories'
export const BODY_MASS_INDEX = 'bmi'
export const HEALTH_CONDITION = 'healthcondition'
export const HEALTH_CONDITION_TODAY = 'healthconditiontoday'

//Quiz
export const BLOOD_PRESSURE_QUIZ = 'pressure'
export const HIGH_BLOOD_PRESSURE = 'high_pressure'
export const LOW_BLOOD_PRESSURE = 'low_pressure'
export const CHRONIC_DISEASE_QUIZ = 'chronic_diseases'
export const DISEASES_RELATIONSHIP_QUIZ = 'diseases_relationship'

// Quiz Blocks
export const HEALTH_VARS = 'healthVars'
export const FEEDING_HABITS = 'feedingHabits'
export const MOOD_AND_HABITS = 'moodAndHabits'
export const HISTORY_AND_DISEASES = 'historyAndDiseases'
export const MEDICAL_EVALUATION = 'medicalEvaluation'

// Question Ids
export const RELATIONSHIP_SUFFER_DISEASE = '1EECE3B2-64F8-41B4-A9A9-328E99D1A539'
export const SUFFER_SOME_DISEASE = 'B2F7E48C-B37A-4D64-8E1F-4D1D6BC7465E'
export const ANALYTICS_HIGH_LEVEL = '49DC52E1-D7E4-4D42-9EE0-9C4DA52772BE'

// Base route
export const BASE_PATH = '/patient/clinic-history'

// History Menu Paths
export const MENU_PATH = '/'
export const HEALTH_VARS_PATH = 'view'
export const DOCUMENTS_HISTORY_PATH = 'documents'
export const HEALTH_DATA = 'health-data'
export const BLOOD_PRESSURE_MONITOR_PATH = 'blood-pressure'
export const MENSTRUAL_CALENDAR_PATH = 'menstrual-calendar'
export const MEDICATION_REMINDER_PATH = 'medication-reminder'

// History Internal Paths
export const QUIZ_PATH = 'quiz'

// Units
export const CM = 'cm'
export const KG = 'kg'
export const DEGREES = '°C'
export const MMHG = 'mmHG'
export const MGDL = 'mg/dl'
export const PPM = 'ppm'
export const RPM = 'rpm'
export const KCAL = 'kcal'
export const UI = 'UI'
export const PERCENT = '%'

// Sections identifiers to open presents in 'section' param
export const HEALTHY_HABITS_SECTION = 'healthyHabits'
export const HEALTH_VARS_SECTION = 'healthVars'
export const ADDITIONAL_VARS_SECTION = 'additionalVarsSection'

// Quiz
export const QUIZ_TYPES = {
		[HEALTH_VARS]: 1,
		[FEEDING_HABITS]: 2,
		[MOOD_AND_HABITS]: 3,
		[HISTORY_AND_DISEASES]: 4,
		[MEDICAL_EVALUATION]: 5
}

export function getQuizNameByType (quizId) {
	return Object.keys(QUIZ_TYPES).find(key => QUIZ_TYPES[key] === quizId)
}

export function getAllQuizTypesIds () {
    return Object.values(QUIZ_TYPES)
}

export function showDontKnowAnswerByQuestionId (questionId) {
    switch (questionId) {
        case RELATIONSHIP_SUFFER_DISEASE:
        case SUFFER_SOME_DISEASE:
        case ANALYTICS_HIGH_LEVEL:
            return true
		default:
			return false
    }
}

// Variables
export const VAR_UNITS = {
		[HEIGHT]: CM,
		[WEIGHT]: KG,
		[TEMPERATURE]: DEGREES,
		[GLUCOSE]: MGDL,
		[HEART_RATE]: PPM,
		[BLOOD_PRESSURE]: MMHG,
		[HDL_CHOLESTEROL]: MGDL,
		[LDL_CHOLESTEROL]: MGDL,
		[TRIGLYCERIDES]: MGDL,
		[BREATHING_FREQUENCY]: RPM,
		[OXYGEN_SATURATION]: PERCENT,
		[WAIST_SIZE]: CM,
		[HIP_SIZE]: CM,
		[FAT_MASS]: KG,
		[FREE_FAT_MASS]: KG,
		[VITAMIN_D]: UI,
		[CALORIES]: KCAL
}

export const FLOAT_VARIABLES = [
	WEIGHT,
	TEMPERATURE,
	FREE_FAT_MASS,
	GLUCOSE,
	TRIGLYCERIDES,
	BODY_MASS_INDEX,
	FAT_MASS,
	HOMA,
	VITAMIN_D,
	CALORIES,
	HEART_RATE,
	BREATHING_FREQUENCY
]

// Healthy habits groups
export const FEEDING_HABIT_GROUP = 1
export const EXERCISE_HABIT_GROUP = 2
export const HABITS_HABIT_GROUP = 3


// WEBPACK FOOTER //
// ./src/constants/clinicHistory.js